import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { BLACK_700, BLUE_500, inputConfig, tokens } from '../../constants';
import { checkIsPlatform, isValidObject } from '../../utils';
import { getTypographyProps, getTypographyStyles } from '../typography/TypographyStyles';
var getInputConfigState = function getInputConfigState(variantStyle) {
  if (variantStyle === void 0) {
    variantStyle = 'default';
  }
  var state = 'newStates';
  if (variantStyle === 'default') state = 'states';
  return state;
};
export var getInputHeight = (size, variantStyle, textAreaHeight) => {
  if (variantStyle !== 'default') {
    return {
      inputSize: size == 'md' ? 56 : 64,
      textAreaSize: textAreaHeight || (size == 'md' ? 112 : 120)
    };
  }
  return {
    inputSize: size == 'md' ? 40 : 48,
    textAreaSize: textAreaHeight || (size == 'md' ? 80 : 80)
  };
};
var getInputWrapperStyles = props => {
  var _a, _b, _c, _d, _e, _f, _g;
  var size = props.size,
    _state = props.state,
    _isDisabled = props.isDisabled,
    pressableStates = props.pressableStates,
    config = props.config,
    readOnly = props.readOnly,
    showAsTextArea = props.showAsTextArea,
    variantStyle = props.variantStyle,
    appendItems = props.appendItems,
    prependItems = props.prependItems,
    showLabelTooltipOnMount = props.showLabelTooltipOnMount,
    showLabelIcon = props.showLabelIcon,
    textAreaHeight = props.textAreaHeight;
  var _ref = pressableStates || {},
    hovered = _ref.hovered,
    focused = _ref.focused;
  var states = getInputConfigState(variantStyle);
  var isDisabled = _isDisabled || _state === 'disabled';
  var state = _state;
  state = isDisabled ? 'disabled' : state;
  var isHoverState = !(isDisabled || readOnly) && (hovered || state === 'hover');
  var _getInputHeight = getInputHeight(size, variantStyle, textAreaHeight),
    inputSize = _getInputHeight.inputSize,
    textAreaSize = _getInputHeight.textAreaSize;
  var stateProps = (_a = config === null || config === void 0 ? void 0 : config[states]) === null || _a === void 0 ? void 0 : _a[state];
  var backgroundColor = (stateProps === null || stateProps === void 0 ? void 0 : stateProps.backgroundColor) || ((_c = (_b = config === null || config === void 0 ? void 0 : config[states]) === null || _b === void 0 ? void 0 : _b.none) === null || _c === void 0 ? void 0 : _c.backgroundColor);
  var borderColor = (stateProps === null || stateProps === void 0 ? void 0 : stateProps.borderColor) || ((_e = (_d = config === null || config === void 0 ? void 0 : config[states]) === null || _d === void 0 ? void 0 : _d.none) === null || _e === void 0 ? void 0 : _e.borderColor);
  var spacing = tokens.spacing;
  var height = showAsTextArea ? textAreaSize : inputSize;
  var showTooltip = (appendItems === null || appendItems === void 0 ? void 0 : appendItems.showTooltip) || (prependItems === null || prependItems === void 0 ? void 0 : prependItems.showTooltip) || showLabelIcon;
  var showTooltipOnMount = (appendItems === null || appendItems === void 0 ? void 0 : appendItems.showTooltipOnMount) || (prependItems === null || prependItems === void 0 ? void 0 : prependItems.showTooltipOnMount) || showLabelTooltipOnMount;
  if (state === 'none' && focused) borderColor = (_g = (_f = config === null || config === void 0 ? void 0 : config[states]) === null || _f === void 0 ? void 0 : _f.focused) === null || _g === void 0 ? void 0 : _g.borderColor;
  return Object.assign({
    width: '100%',
    flexDirection: 'row',
    borderWidth: isHoverState ? spacing.SPACING_2 : spacing.SPACING_1,
    borderRadius: tokens.borderRadius.BORDER_RADIUS_8,
    backgroundColor,
    borderColor,
    overflow: showTooltip || showTooltipOnMount ? 'visible' : 'hidden',
    height,
    alignItems: 'center'
  }, (showTooltip || showTooltipOnMount) && {
    zIndex: -1
  });
};
var getLabelStyles = props => {
  var _a, _b, _c;
  var config = props.config,
    _state = props.state,
    _isDisabled = props.isDisabled,
    showAsTextArea = props.showAsTextArea,
    variantStyle = props.variantStyle;
  var states = getInputConfigState(variantStyle);
  var isDisabled = _isDisabled || _state === 'disabled';
  var state = _state;
  state = isDisabled ? 'disabled' : state;
  var stateProps = (_a = config === null || config === void 0 ? void 0 : config[states]) === null || _a === void 0 ? void 0 : _a[state];
  var color = (stateProps === null || stateProps === void 0 ? void 0 : stateProps.labelColor) || ((_c = (_b = config === null || config === void 0 ? void 0 : config[states]) === null || _b === void 0 ? void 0 : _b.none) === null || _c === void 0 ? void 0 : _c.labelColor);
  var marginTop = tokens.spacing.SPACING_8;
  if (showAsTextArea) marginTop = tokens.spacing.SPACING_4;
  return Object.assign(Object.assign({}, variantStyle === 'withLabel' && {
    marginTop
  }), {
    color
  });
};
var getPrependStyles = props => {
  var _a, _b, _c, _d;
  var _state = props.state,
    _isDisabled = props.isDisabled,
    pressableStates = props.pressableStates,
    config = props.config,
    readOnly = props.readOnly,
    variantStyle = props.variantStyle,
    showDivider = props.showDivider;
  var _ref2 = pressableStates || {},
    hovered = _ref2.hovered,
    focused = _ref2.focused;
  var isDisabled = _isDisabled || _state === 'disabled';
  var isHoverState = !(isDisabled || readOnly) && (hovered || _state === 'hover');
  var prependBorderColorState = isDisabled ? 'disabled' : 'none';
  var states = getInputConfigState(variantStyle);
  var borderColor = (_b = (_a = config === null || config === void 0 ? void 0 : config[states]) === null || _a === void 0 ? void 0 : _a[prependBorderColorState]) === null || _b === void 0 ? void 0 : _b.borderColor;
  var spacing = tokens.spacing;
  var padding = isHoverState ? spacing.SPACING_11 : spacing.SPACING_12;
  if (_state === 'none' && focused) borderColor = (_d = (_c = config === null || config === void 0 ? void 0 : config[states]) === null || _c === void 0 ? void 0 : _c.focused) === null || _d === void 0 ? void 0 : _d.borderColor;
  return Object.assign({
    paddingLeft: padding
  }, variantStyle === 'default' && showDivider && {
    paddingRight: spacing.SPACING_12,
    borderRightWidth: 1,
    borderColor
  });
};
var getTextInputStyles = props => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  var theme = props.theme,
    size = props.size,
    state = props.state,
    _isDisabled = props.isDisabled,
    config = props.config,
    showAsTextArea = props.showAsTextArea,
    pressableStates = props.pressableStates,
    variantStyle = props.variantStyle,
    label = props.label;
  var states = getInputConfigState(variantStyle);
  var isDisabled = _isDisabled || state === 'disabled';
  var type = showAsTextArea ? "body-para-" + (size == 'md' ? 'sm' : 'md') : "body-single-line-" + (size == 'md' ? 'sm' : 'md');
  if (variantStyle !== 'default') {
    type = showAsTextArea ? "body-para-" + (size == 'md' ? 'md' : 'lg') : "body-single-line-" + (size == 'md' ? 'md' : 'lg');
  }
  var _state = isDisabled || state === 'disabled' ? 'disabled' : state;
  var color = ((_b = (_a = config === null || config === void 0 ? void 0 : config[states]) === null || _a === void 0 ? void 0 : _a[_state]) === null || _b === void 0 ? void 0 : _b.inputTextColor) || ((_d = (_c = config === null || config === void 0 ? void 0 : config[states]) === null || _c === void 0 ? void 0 : _c.none) === null || _d === void 0 ? void 0 : _d.inputTextColor);
  var typographyProps = getTypographyProps({}, {
    theme
  });
  var typographyStyles = getTypographyStyles(Object.assign(Object.assign({}, typographyProps), {
    type
  }));
  var stateColor = ((_f = (_e = config === null || config === void 0 ? void 0 : config[states]) === null || _e === void 0 ? void 0 : _e[state]) === null || _f === void 0 ? void 0 : _f.borderColor) || BLUE_500;
  if (state === 'none' && (pressableStates === null || pressableStates === void 0 ? void 0 : pressableStates.focused)) {
    stateColor = (_h = (_g = config === null || config === void 0 ? void 0 : config[states]) === null || _g === void 0 ? void 0 : _g.focused) === null || _h === void 0 ? void 0 : _h.borderColor;
  }
  var paddingVertical = tokens.spacing.SPACING_8;
  var paddingBottom = tokens.spacing.SPACING_8;
  if (showAsTextArea && size === 'md') {
    paddingVertical = tokens.spacing.SPACING_4;
    paddingBottom = tokens.spacing.SPACING_4;
  }
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, typographyStyles === null || typographyStyles === void 0 ? void 0 : typographyStyles.typography), {
    lineHeight: checkIsPlatform('ios') && !showAsTextArea ? undefined : (_j = typographyStyles === null || typographyStyles === void 0 ? void 0 : typographyStyles.typography) === null || _j === void 0 ? void 0 : _j.lineHeight,
    flexShrink: 1,
    flexGrow: 1,
    color,
    padding: 0
  }), variantStyle === 'withoutLabel' && {
    paddingVertical
  }), variantStyle === 'withLabel' && label && {
    paddingBottom
  }), checkIsPlatform('web') && {
    caretColor: stateColor
  }), showAsTextArea && {
    textAlignVertical: 'top'
  });
};
var getAppendStyles = props => {
  var state = props.state,
    pressableStates = props.pressableStates,
    _isDisabled = props.isDisabled,
    readOnly = props.readOnly;
  var _ref3 = pressableStates || {},
    hovered = _ref3.hovered;
  var isDisabled = _isDisabled || state === 'disabled';
  var isHoverState = !(isDisabled || readOnly) && (hovered || state === 'hover');
  var spacing = tokens.spacing;
  return {
    paddingRight: isHoverState ? spacing.SPACING_11 : spacing.SPACING_12
  };
};
var getHintStyles = props => {
  var _a, _b, _c, _d;
  var _state = props.state,
    useStateHintColor = props.useStateHintColor,
    config = props.config,
    _isDisabled = props.isDisabled,
    variantStyle = props.variantStyle,
    _props$hintTextStyle = props.hintTextStyle,
    hintTextStyle = _props$hintTextStyle === void 0 ? {} : _props$hintTextStyle;
  var states = getInputConfigState(variantStyle);
  var state = _isDisabled || _state === 'disabled' ? 'disabled' : _state;
  var noneHintColor = (_b = (_a = config === null || config === void 0 ? void 0 : config[states]) === null || _a === void 0 ? void 0 : _a.none) === null || _b === void 0 ? void 0 : _b.hintColor;
  var statesColors = (_d = (_c = config === null || config === void 0 ? void 0 : config[states]) === null || _c === void 0 ? void 0 : _c[state]) === null || _d === void 0 ? void 0 : _d.hintColor;
  var color = useStateHintColor && statesColors || noneHintColor;
  return Object.assign(Object.assign({}, isValidObject(hintTextStyle) && hintTextStyle), {
    color
  });
};
var getCharacterCounterStyles = props => {
  var _a, _b, _c;
  var config = props.config,
    _state = props.state,
    _isDisabled = props.isDisabled,
    variantStyle = props.variantStyle;
  var states = getInputConfigState(variantStyle);
  var isDisabled = _isDisabled || _state === 'disabled';
  var state = _state;
  state = isDisabled ? 'disabled' : state;
  var stateProps = (_a = config === null || config === void 0 ? void 0 : config[states]) === null || _a === void 0 ? void 0 : _a[state];
  var color = (stateProps === null || stateProps === void 0 ? void 0 : stateProps.characterCounterColor) || ((_c = (_b = config === null || config === void 0 ? void 0 : config[states]) === null || _b === void 0 ? void 0 : _b.none) === null || _c === void 0 ? void 0 : _c.characterCounterColor);
  return Object.assign({
    color,
    flexShrink: 0,
    marginHorizontal: tokens.spacing.SPACING_12
  }, variantStyle !== 'default' && {
    marginRight: tokens.spacing.SPACING_0
  });
};
export var getInputStyles = (props, pressableStates) => {
  var _a, _b, _c, _d;
  var _props$config = props.config,
    config = _props$config === void 0 ? {} : _props$config,
    state = props.state,
    showAsTextArea = props.showAsTextArea,
    size = props.size,
    variantStyle = props.variantStyle;
  var states = getInputConfigState(variantStyle);
  var stateColor = ((_b = (_a = config === null || config === void 0 ? void 0 : config[states]) === null || _a === void 0 ? void 0 : _a[state]) === null || _b === void 0 ? void 0 : _b.borderColor) || BLUE_500;
  var showPrepend = props === null || props === void 0 ? void 0 : props.showPrepend;
  var showAppend = props === null || props === void 0 ? void 0 : props.showAppend;
  if (state === 'none' && (pressableStates === null || pressableStates === void 0 ? void 0 : pressableStates.focused)) {
    stateColor = (_d = (_c = config === null || config === void 0 ? void 0 : config[states]) === null || _c === void 0 ? void 0 : _c.focused) === null || _d === void 0 ? void 0 : _d.borderColor;
  }
  var spacing = tokens.spacing;
  var paddingHorizontal = checkIsPlatform('web') ? spacing.SPACING_16 : spacing.SPACING_12;
  var paddingVertical = showAsTextArea ? variantStyle !== 'default' ? size == 'md' ? spacing.SPACING_4 : spacing.SPACING_8 : spacing.SPACING_10 : spacing.SPACING_0;
  return StyleSheet.create({
    inputWrapper: getInputWrapperStyles(Object.assign(Object.assign({}, props), {
      pressableStates
    })),
    prepend: getPrependStyles(Object.assign(Object.assign({}, props), {
      pressableStates
    })),
    textInputContainer: Object.assign(Object.assign(Object.assign({
      flexShrink: 1,
      flexGrow: 1,
      paddingHorizontal
    }, variantStyle !== 'default' && showPrepend && {
      paddingLeft: spacing.SPACING_8
    }), variantStyle !== 'default' && showAppend && {
      paddingRight: spacing.SPACING_8
    }), !checkIsPlatform('ios') && {
      paddingVertical
    }),
    textInput: getTextInputStyles(Object.assign(Object.assign({}, props), {
      pressableStates
    })),
    append: getAppendStyles(Object.assign(Object.assign({}, props), {
      pressableStates
    })),
    cursorColor: {
      backgroundColor: stateColor
    }
  });
};
export var getInputInitialStyles = (props, isActive) => {
  var variantStyle = props.variantStyle,
    appendItems = props.appendItems,
    prependItems = props.prependItems,
    showLabelTooltipOnMount = props.showLabelTooltipOnMount,
    showLabelIcon = props.showLabelIcon;
  var prependAppendItemShowTooltip = (prependItems === null || prependItems === void 0 ? void 0 : prependItems.showTooltip) || (appendItems === null || appendItems === void 0 ? void 0 : appendItems.showTooltip);
  var prependAppendItemShowTooltiponMount = (appendItems === null || appendItems === void 0 ? void 0 : appendItems.showTooltipOnMount) || (prependItems === null || prependItems === void 0 ? void 0 : prependItems.showTooltipOnMount);
  var showTooltip = prependAppendItemShowTooltip || showLabelIcon;
  var showTooltipOnMount = prependAppendItemShowTooltiponMount || showLabelTooltipOnMount;
  return StyleSheet.create({
    label: getLabelStyles(props),
    hint: getHintStyles(props),
    hintActionContainer: {
      justifyContent: 'center'
    },
    hintAction: {
      marginLeft: tokens.spacing.SPACING_4
    },
    actionCtaContainer: Object.assign({
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: tokens.spacing.SPACING_4
    }, (prependAppendItemShowTooltip || prependAppendItemShowTooltiponMount) && {
      zIndex: -1
    }),
    labelContainer: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    },
    infoIcon: {
      marginLeft: tokens.spacing.SPACING_4
    },
    actionCta: {
      paddingBottom: tokens.spacing.SPACING_0,
      paddingTop: tokens.spacing.SPACING_0,
      height: 'auto'
    },
    hintContainer: Object.assign(Object.assign(Object.assign({}, (showTooltip || showTooltipOnMount) && {
      zIndex: -2
    }), {
      marginTop: tokens.spacing.SPACING_4,
      flexDirection: 'row'
    }), variantStyle !== 'default' && {
      marginLeft: tokens.spacing.SPACING_12
    }),
    hintInnerContent: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center'
    },
    characterCounter: getCharacterCounterStyles(props),
    otpContainer: {
      flexDirection: 'row'
    },
    textInputOtpContainer: {
      position: 'absolute',
      color: 'transparent'
    },
    otpSeparatorWrapper: {
      width: tokens.spacing.SPACING_24,
      alignItems: 'center',
      alignSelf: 'center'
    },
    otpSeparatorSymbol: {
      width: tokens.spacing.SPACING_4,
      height: tokens.spacing.SPACING_4,
      borderRadius: tokens.spacing.SPACING_2,
      backgroundColor: BLACK_700
    },
    otpTextStyle: {
      textAlign: 'center',
      color: isActive ? BLUE_500 : BLACK_700,
      padding: 0,
      width: checkIsPlatform('web') ? tokens.spacing.SPACING_16 : tokens.spacing.SPACING_14
    }
  });
};
export var getCharacterCounter = props => {
  var value = props.value,
    maxLength = props.maxLength;
  return "" + value.length + (maxLength ? "/" + maxLength : '');
};
export var getRemainingCharacterCounter = props => {
  var value = props.value,
    maxLength = props.maxLength;
  var _rem = maxLength - (value === null || value === void 0 ? void 0 : value.length) || '';
  return _rem + " characters remaining";
};
export var getInputProps = (props, context) => {
  var _a, _b, _c, _d;
  var theme = props.theme || context.theme;
  var configProps = merge(inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.input) === null || _a === void 0 ? void 0 : _a[theme]);
  var state = (props === null || props === void 0 ? void 0 : props.state) || (configProps === null || configProps === void 0 ? void 0 : configProps.state);
  var isDisabled = state === 'disabled' || (props === null || props === void 0 ? void 0 : props.isDisabled);
  var _state = isDisabled ? 'disabled' : state;
  var states = getInputConfigState(props === null || props === void 0 ? void 0 : props.variantStyle);
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    placeholderTextColor: (_d = (_c = (_b = configProps === null || configProps === void 0 ? void 0 : configProps.config) === null || _b === void 0 ? void 0 : _b[states]) === null || _c === void 0 ? void 0 : _c[_state]) === null || _d === void 0 ? void 0 : _d.placeholderColor
  });
};